// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetOptInHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentCreditReportGetOptInHandler_getOptIn,
  RentCreditReportGetOptInHandler_getOptIn_Path,
} from '@zg-rentals/ts-rent-payment-client';

import type {
  RentCreditReportOptInStatusWebApiRequestDto,
  RentCreditReportOptInStatusWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export type RentCreditReportGetOptInHandler_getOptIn_Options = UseQueryOptions<
  RentCreditReportOptInStatusWebApiResponseDto,
  unknown,
  RentCreditReportOptInStatusWebApiResponseDto,
  Array<string | RentCreditReportOptInStatusWebApiRequestDto>
>;

const RentCreditReportGetOptInHandler_getOptIn_GetKey = (postData: RentCreditReportOptInStatusWebApiRequestDto) => [
  RentCreditReportGetOptInHandler_getOptIn_Path,
  postData,
];

/**
 * Get opt in status for rent reporting
 */
export const useRentCreditReportGetOptInHandler_getOptIn = (
  postData: RentCreditReportOptInStatusWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentCreditReportGetOptInHandler_getOptIn_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentCreditReportGetOptInHandler_getOptIn_GetKey(postData),
    queryFn: () => RentCreditReportGetOptInHandler_getOptIn(postData, httpClient),
  });
};
useRentCreditReportGetOptInHandler_getOptIn.getKey = RentCreditReportGetOptInHandler_getOptIn_GetKey;
